/***********************************************
* CutTool.js
* 
* Cuts a part of the pointcloud
***********************************************/
/* Layout files */
import '../../assets/style/Tools.css';

/* Global imports */
import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';

/* Local imports */
import API from '../API';
import UploadZone from './UploadZone';

function VolumeTool(props) {
    const [zone, setZone] = useState(0);
    const [id,   setId]   = useState(props.id);
    const [volumeId, setVolumeId] = useState(0);
    const [isDone, setIsDone] = useState(false);
    const [running, setRunning] = useState(false);

    /* Calculated Values */
    const [volume, setVolume] = useState(0.0);
    const [added,  setAdded]  = useState(0.0);
    const [removed, setRemoved] = useState(0.0);
    const [surface, setSurface] = useState(0.0);

    const [availableDates, setAvailableDates] = useState([]);
    const [selectedDate1, setSelectedDate1] = useState("");
    const [selectedDate2, setSelectedDate2] = useState("");

    useEffect(() => {
        setId(props.id);
        setSelectedDate1("");
        setSelectedDate2("");
        API.GetOutputDates(props.id, (reply) => {setAvailableDates(reply);});
    }, [props.id]);

    useEffect(() => {
        if(volumeId !== 0) {
            const interval = setInterval(() => {
                API.IsVolumeDone(volumeId, (reply) => {
                    setIsDone(reply['isDone']);
                    if(reply['isDone'] === true) {
                        clearInterval(interval);
                    
                        const addedTmp = parseFloat(reply['added']);
                        const removedTmp = parseFloat(reply['removed']);
                        const volumeTmp = parseFloat(reply['volume']);
                        const surfaceTmp = parseFloat(reply['surface']);

                        if(addedTmp < removedTmp) {
                            setVolume(volumeTmp  * -1);
                        } else {
                            setVolume(volumeTmp);
                        }

                        setSurface(surfaceTmp);
                        setAdded(addedTmp);
                        setRemoved(removedTmp);
                        setRunning(false);
                    }
                });
            }, 10000);
            return () => clearInterval(interval);
        }
    }, [volumeId]);

    const dateSelect = (value, setValue) => {
        var options = [<option key="emptyOption" value="" disabled>Select date</option>];
        availableDates.forEach((date) => { options.push(<option key={date} value={date}>{date}</option>) });
        return <select name="dateSelect" onChange={(e) => {setValue(e.target.value);}} value={value}>{options}</select>;
    }

    return (
        <div className='flexTool'>
            <div className='toolTitle'>{props.t("volume")}</div>
            <div><label>Select DXF zone</label><UploadZone t={props.t} id={id} onZoneId={(zoneid) => {setZone(zoneid); console.log(zoneid);}}/></div>
            <div><label>Select reference scan</label>
                {dateSelect(selectedDate1, setSelectedDate1)}
            </div>
            <div><label>Select situation scan</label>
                {dateSelect(selectedDate2, setSelectedDate2)}
            </div>
            <div>
                <button 
                    disabled={(zone === 0) || (selectedDate1 === "") || (selectedDate2 === "")}
                    className='bigButton' 
                    onClick={() => {
                        setRunning(true);
                        API.GetVolume(id, zone, selectedDate1, selectedDate2, (reply) => {setVolumeId(reply['id']);})
                    }}
                >
                        {props.t("calculateVolume")}
                </button>
            </div>
            <div>
                <label>Surface</label>
                {(isDone) ? surface + " m²" : "... m²"}
            </div>
            <div>
                <label>Volume</label>
                {(!isDone) ? ((running) ? <div><div className="toolsSpinner"></div></div> : "... m³") : (volume + " m³")}
            </div>
            <div>
                <label>Fill</label>
                {(isDone) ? added + " m³" : "... m³"}
                <label>Cut</label>
                {(isDone) ? removed + " m³" : "... m³"}
            </div>
        </div>
    );
}

export default withTranslation("Projects")(VolumeTool);